import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const workflowDesignerRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-pages',
	path: '/secure/admin/(workflows/|)(WorkflowDesigner|ViewWorkflowSteps).jspa',
};
